;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var Controller = APP.module('Controller');
	var Router     = APP.module('Router');
	var Model      = APP.module('Model');
	var View       = APP.module('View');
	var Layout     = APP.module('Layout');
	var Collection = APP.module('Collection');

	Controller.Account = function(){

	};

	_.extend(Controller.Account.prototype, {
		start: function () {
			this.builder  = new Model.AccountBuilder();
			this.fb_model = Model.FacebookConnect ? new Model.FacebookConnect() : null;
			this.view = new Layout.LeftSidebar();
			this.layout = new  Layout.AccountLayout(this.builder);
			this.user = APP.module('instance').user;
			
			console.log("instance user", this.user);
			var sidebar = this.getSidebar();

			APP.main.show(this.view);
			this.view.aside.show(sidebar);
			this.view.main.show(this.layout);
		},

		getSidebar(){
			return new Layout.Sidebar({
				widgets_list: this.builder.get('widgets'),
				widgets_options: {
					side_menu_items: this.builder.get('menuItems')
				}
			});
		},

		account: function() {
			// Build layout
			this.start();

			// Call getProfile and wait for it to complete
			this.user.getProfile(this.user.id).done(() => {
				this.collectionCountries = new Collection.Countries();
				this.collectionCountries.fetch();

				this.collectionStates = new Collection.States();
				this.collectionStates.fetch();

				this.squads = new Collection.Squads();
				this.squads.fetch();
				var account_update_view = new View.AccountUpdate({
					squads     : this.squads,
					model      : this.user,
					countries  : this.collectionCountries.toJSON(),
					states     : this.collectionStates.toJSON(),
					fields     : this.builder.get('your_details_fields'),
					template   : this.builder.get('form_templates')
				});
				this.layout.account.show(account_update_view);
			});
		},
		notifications: function(token) {
			this.start();
			var notifications = new View.Notifications({
				model     : this.user,
				fields    : this.builder.get('notification_fields'),
				template  : JST[this.builder.get('form_templates')+'notifications'],
				form_template  : this.builder.get('form_templates')
			});
			this.layout.notifications.show(notifications);
		},
		socialConnection: function(){
			this.start();

			var socialConnections = new View.SocialConnections({
				model           : this.user,
				fb_model        : this.fb_model,
				socialConnect   : this.builder.get('socialConnect'),
				template        : this.builder.get('form_templates'),
				builderOptions  : this.builder.toJSON()
			});
			this.layout.socialConnections.show(socialConnections);
		},
		changePassword: function(){
			this.start();
			var changePassword = new View.AccountChangePassword({
				model    : this.user,
				template : this.builder.get('form_templates')
			});
			this.layout.changePassword.show(changePassword);
		},
		coachesBox: function(){
			var socialConnections = new View.SocialConnections({
				//model: this.user,
				//fb_model : this.fb_model,
				//socialConnect: this.builder.get('socialConnect'),
				//template: this.builder.get('form_templates')
			});
			this.layout.socialConnections.show(socialConnections);
			return this;
		}
	});

	APP.on('start', function() {
		var controller = new Controller.Account();
		var router = new Router.Account({ controller: controller });
	});

}(window, APP, Backbone, Marionette, $, _));
